export default (t: string => string, enabled: boolean, config: Object) => ({
  serviceConfigurationTemplate: { "ui:widget": "hidden" },
  selfServiceEnabled: { "ui:widget": "hidden" },
  name: { "ui:widget": "hidden" },
  contractType: { "ui:widget": "hidden" },
  emailAppearAs: { "ui:widget": "hidden" },
  emailAddress: { "ui:widget": "hidden" },
  isEnabled: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: t("SERVICE_STATUS"),
      description: t("CLIENT_SERVICE_STATUS_DESCRIPTION"),
    },
  },
  activeFrom: {
    "ui:widget": "date-picker",
    "ui:options": {
      dateFormat: config.dateFormatBE,
      description: t("CLIENT_START_DATE_DESCRIPTION"),
    },
  },
  activeTo: {
    "ui:widget": "date-picker",
    "ui:options": {
      dateFormat: config.dateFormatBE,
    },
  },
  serviceType: {
    "ui:options": {
      label: t("SERVICE_TYPE"),
      description: t("CLIENT_SERVICE_TYPE_DESCRIPTION"),
    },
  },
  blockConsent: {
    "ui:widget": "switch-button",
    "ui:options": {
      description: t("CLIENT_CONSENT_BLOCK_DESCRIPTION"),
    },
  },
  overflowSupport: {
    "ui:options": {
      label: t("OVERFLOW_STATUS"),
      description: t("CLIENT_OVERFLOW_DESCRIPTION"),
    },
  },
  absenceLineNumber: {
    "ui:options": {
      description: t("CLIENT_ABSENCE_LINE_DESCRIPTION"),
    },
  },
  "ui:order": [
    "activeFrom",
    "activeTo",
    "serviceType",
    "absenceLineNumber",
    "emailAddress",
    "overflowSupport",
    "emailAppearAs",
    "contractType",
    "blockConsent",
    "isEnabled",
    "*",
  ],
});
